<template>
  <div class="groupDetailBox">
    <div class="top"></div>
    <div
      class="main"
      v-if="info"
    >
      <div class="groupInfo">
        <div class="orderInfo">
          <p class="name ellipsis">{{ info.productDTO.productname }}</p>
          <p class="teacher ellipsis">
            {{
              info.productDTO.teachername +
              " · " +
              info.productDTO.lessoncount +
              "讲"
            }}
          </p>
          <div class="price">
            <span class="newPrice"><em>¥</em>{{ info.productDTO.groupprice }}</span>
            <s class="oldPrice">¥{{ info.productDTO.sellprice }}</s>
          </div>
        </div>
        <div class="dash"></div>
        <div class="groupDetail">
          <p
            class="success status"
            v-if="info.groupStatus == 1002"
          >
            <i></i><span>拼团成功</span>
          </p>
          <p
            class="fail status"
            v-else-if="info.groupStatus == 1003"
          >
            <i></i><span>拼团失败</span>
          </p>
          <p
            class="tip"
            v-else
          >
            还差<em> {{ info.needNum }}</em>人即可成团
          </p>
          <div class="userList" v-if="info.ordergroupdetailDTOList&&info.ordergroupdetailDTOList.length">
            <ul>
              <li
                v-for="(item, index) in info.groupnum"
                :key="index"
                :style="{ zIndex: 10 - index }"
              >
                <div class="img">
                  <img
                    v-if="info.ordergroupdetailDTOList[index]"
                    :src="info.ordergroupdetailDTOList[index].custheadimg||$store.state.state.defaultHeaderimg"
                    alt=""
                  />
                  <span v-else></span>
                  <i v-if="
                      info.ordergroupdetailDTOList[index] &&
                      info.ordergroupdetailDTOList[index].captain == 'Y'
                    ">团长</i>
                </div>
              </li>
            </ul>
          </div>
          <div
            v-if="btnInfo"
            :class="['submit', btnInfo.btnClass]"
            @click="share(btnInfo.type)"
          >
            {{ btnInfo.text }}
          </div>
          <div
            class="countDownBox"
            v-if="info.groupStatus == 1000 || info.groupStatus == 1001"
          >
            <p>距离拼团结束还剩</p>
            <div class="countDown">
              <span>{{ hours>0?hours:'00' }}</span> <em>:</em> <span>{{ minutes>0?minutes:'00' }}</span><em>:</em><span>{{ seconds>0?seconds:'00' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="stepBox common">
        <div class="commonTop">
          <div class="title">拼团流程</div>
        </div>
        <div class="commonContent">
          <ul>
            <li
              v-for="(item, index) in stepList"
              :key="index"
            >
              <div class="step">
                <i>{{ index + 1 }}</i>
              </div>
              <div class="text">
                <span>{{ item.text1 }}</span>
                <span>{{ item.text2 }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="rule common">
        <div class="commonTop">
          <div class="title">支付说明</div>
        </div>
        <div class="commonContent">
          <ul>
            <li
              v-for="(item, index) in rule"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "拼团详情",
    };
  },
  data() {
    return {
      stepList: [
        { text1: "选择", text2: "开团/参团" },
        { text1: "支付并", text2: "邀请好友" },
        { text1: "人满成团", text2: "不满退团" },
      ],
      rule: [
        "· 拼团有效期为24小时，只有当拼团人数全部对商品以拼团价完成支付后，才能拼团成功。",
        "· 只有以拼团价完成支付之后才可以邀请好友参团。",
        "· 拼团人数未达到开团人数，即视为拼团失败，已支付费用在72小时内自动返还至微信余额。",
        "· 拼团中的商品不可以再以原价购买，发起拼团后不可以主动取消。",
      ],
      info: "",
      hours: 0,
      minutes: 0,
      seconds: 0,
      ordergroupheadid: "",
      userinfo: "",
      sharePage: false, //判断是否是分享页面
      haveMime: false, //参团列表中是否有自己
      btnInfo: "",
    };
  },
  components: {},
  created() {
    this.userInfo = this.$store.state.state.userinfo ? JSON.parse(JSON.stringify(this.$store.state.state.userinfo)) : "";
    this.sharePage = this.$route.query.share;
  },
  mounted() {
    this.ordergroupheadid = this.$route.query.ordergroupheadid ? this.$route.query.ordergroupheadid : "";
  this.getInfo();
  },
  methods: {
    btnOpation() {
      var info = this.info;
      var obj = {};
      if (this.sharePage) {
        if (!this.userInfo && (info.groupStatus == 1001||info.groupStatus == 1000)) {
          obj.text = "参与拼团";
          obj.btnClass = "active";
          obj.type = "join";
          this.btnInfo = obj;
        } else {
          var ordergroupdetailDTOList = info.ordergroupdetailDTOList||[];
          new Promise((resolve, reject) => {
            for (var i = 0; i < ordergroupdetailDTOList.length; i++) {
              if (this.userInfo.customerid == ordergroupdetailDTOList[i].customerid) {
                this.haveMime = true;
              }
              if (i == ordergroupdetailDTOList.length - 1) {
                resolve();
              }
            }
          }).then((res) => {
            if (this.haveMime) {
              // groupStatus 1001 评团中 1002成功 1003 失败 1004 名额已预订
              if (info.groupStatus == 1002 || info.groupStatus == 1003) {
                this.btnInfo = {
                  text: "查看订单",
                  btnClass: "default",
                  type: "detail",
                };
              } else if (info.groupStatus == 1001||info.groupStatus == 1000) {
                this.btnInfo = {
                  text: "立即邀请好友",
                  btnClass: "active",
                  type: "invite",
                };
              }
            } else {
              if (info.groupStatus == 1001||info.groupStatus == 1000) {
                this.btnInfo = {
                  text: "参与拼团",
                  btnClass: "active",
                  type: "join",
                };
              }
            }
          });
        }
      } else {
        if (info.groupStatus == 1002 || info.groupStatus == 1003) {
          obj.text = "查看订单";
          obj.btnClass = "default";
          obj.type = "detail";
          this.btnInfo = obj;
        } else if (info.groupStatus == 1001||info.groupStatus == 1000) {
          obj.text = "立即邀请好友";
          obj.btnClass = "active";
          obj.type = "invite";
          this.btnInfo = obj;
        }
      }
    },
    getInfo() {
      var _this = this;
      var obj = {
        ordergroupheadid: this.ordergroupheadid,
      };

      this.$post(
        "/iart-api-crm/api/crm/promotiongroup/queryGroupDetail",
        obj
      ).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          this.systemtime = res.systemtime;
          this.btnOpation();
          if (res.data.groupStatus == 1001||res.data.groupStatus == 1000) {
            this.endTime =res.data.groupEndDate;
            if (_this.endTime > _this.systemtime) {
              _this.countdown();
              this.timeStop = setInterval(() => {
                _this.systemtime += 1000;
                if (_this.endTime < _this.systemtime) {
                  _this.getInfo();
                  clearInterval(_this.timeStop)
                }
                _this.countdown();
              }, 1000);
            }
          }
          this.shareLink();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    share(type) {
      var info = this.info;
      switch (type) {
        case "invite":
          this.util.shareBox();
          break;
        case "detail":
          this.$router.push({
            path: "/h5/mine/order/orderDetail",
            query: {
              orderId: info.orderid,
            },
          });
          break;
        case "join":
          if (!this.util.loginStatus()) {
            this.util.wechatLogin();
            return false;
          } else {
            this.util.showLoading();
            var obj = {
              ordergroupheadid: this.ordergroupheadid,
            };
            this.$post("/iart-api-crm/api/crm/promotiongroup/queryGroupDetail", obj).then((res) => {
              this.util.hideLoading();
              if (res.code == 1) {
                var groupStatus = res.data.groupStatus;
                switch (groupStatus - 0) {
                  case 1000:
                  case 1001:
                    this.$router.push({
                      path: "/h5/common/order",
                      query: {
                        coursetype: 1004,
                        courseid: this.ordergroupheadid,
                        ordertype: 1000,
                        productid: this.info.productid,
                      },
                    });
                    break;
                  case 1002:
                    this.util.toast({ msg: "该团购已拼团成功" });
                    break;
                  case 1003:
                    this.util.toast({ msg: "该团购已拼团失败" });
                    break;
                  case 1004:
                    this.util.toast({ msg: "该团购已不可参与拼团" });
                    break;
                  default:
                    break;
                }
              } else {
                this.util.toast({ msg: res.message });
              }
            });
          }

          break;
        default:
          break;
      }
    },
    countdown() {
      var startTime = this.systemtime;
      var endTime = this.endTime;
      var time = parseInt(endTime - startTime);
      var days = Math.floor(time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((time / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((time / (1000 * 60)) % 60);
      var seconds = Math.floor((time / 1000) % 60);
      this.days = days >= 10 ? days : "0" + (days>0?days:0);
      this.hours = hours >= 10 ? hours : "0" + (hours>0?hours:0);
      this.seconds = seconds >= 10 ? seconds : "0" + (seconds>0?seconds:0);
      this.minutes = minutes >= 10 ? minutes : "0" + (minutes>0?minutes:0);
    },
    shareLink() {
      var _this = this;
      var url =
        _this.$store.state.state.shareUrl +
        "/h5/course/groupDetail?share=true&ordergroupheadid=" +
        _this.ordergroupheadid;
      // if (this.$store.state.state.userinfo.customercode) {
      //   url += "&sharecode=" + this.$store.state.state.userinfo.customercode;
      // }
      var data = {
        title: "邀请你参与拼团",
        desc: this.info.productDTO ? this.info.productDTO.signature : "",
        url: url,
        imgUrl: this.info.productDTO ? this.info.productDTO.shareicon : "",
      };
      this.util.shareLink( data).then(function () {
        // _this.shareCount();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.groupDetailBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(244, 244, 247, 1);
  overflow-x: hidden;
  overflow-y: auto;
  .top {
    width: 150%;
    height: 42vh;
    background: rgba(201, 55, 61, 1);
    position: relative;
    z-index: 1;
    border-radius: 0 0 50% 50%;
    margin-left: -25%;
    z-index: 10;
    position: relative;
  }
  .main {
    position: relative;
    margin: 0 16px;
    margin-top: -30vh;
    z-index: 11;
    .groupInfo {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
      padding: 0 16px;
      .orderInfo {
        padding: 20px 0 24px;
        .name {
          font-size: 18px;
          line-height: 25px;
          color: rgba(53, 54, 60, 1);
          font-weight: bold;
        }
        .teacher {
          font-size: 13px;
          line-height: 18px;
          color: rgba(53, 54, 60, 1);
          margin-top: 8px;
          font-weight: 300;
        }
        .price {
          margin-top: 8px;
          .newPrice {
            font-size: 22px;
            line-height: 28px;
            color: rgba(53, 54, 60, 1);
            font-weight: bolder;
            vertical-align: middle;
            em {
              font-size: 12px;
              line-height: 17px;
              margin-right: 4px;
            }
          }
          .oldPrice {
            vertical-align: middle;
            margin-left: 8px;
            font-size: 12px;
            line-height: 15px;
            color: rgba(174, 175, 177, 1);
            font-weight: 500;
          }
        }
      }
      .dash {
        border-top: 0.5px dashed rgba(53, 54, 60, 0.3);
        position: relative;
      }
      .dash::before {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: rgba(201, 55, 61, 1);
        position: absolute;
        left: -24px;
        top: -8px;
      }
      .dash::after {
        content: " ";
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: rgba(201, 55, 61, 1);
        position: absolute;
        right: -24px;
        top: -8px;
      }
      .groupDetail {
        padding: 36px 28px;
        text-align: center;
        .tip {
          font-size: 14px;
          line-height: 20px;
          color: rgba(174, 175, 177, 1);
          font-weight: 400;
          em {
            font-weight: normal;
            color: rgba(53, 54, 60, 1);
          }
        }
        .status {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          i {
            display: inline-block;
            width: 44px;
            height: 44px;
          }
          span {
            font-size: 14px;
            line-height: 20px;
            margin-top: 8px;
          }
        }
        .success {
          i {
            background: url(../../../assets/img/h5/success.png) no-repeat;
            background-size: 44px 44px;
          }
          span {
            color: rgba(201, 55, 61, 1);
          }
        }
        .fail {
          i {
            background: url(../../../assets/img/h5/fail.png) no-repeat;
            background-size: 44px 44px;
          }
          span {
            color: rgba(174, 175, 177, 1);
          }
        }
        .userList {
          text-align: center;
          margin-top: 16px;
          ul {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            li {
              display: inline-block;
              position: relative;
              .img {
                width: 56px;
                height: 56px;
                border: 0.5px solid rgba(231, 231, 231, 1);
                padding: 4px;
                border-radius: 50%;
                position: relative;
                background: #fff;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                }
                i {
                  background: RGBA(158, 164, 181, 1);
                  font-size: 12px;
                  line-height: 17px;
                  width: 30px;
                  height: 17px;
                  text-align: center;
                  border-radius: 3px;
                  position: absolute;
                  bottom: -5px;
                  left: 50%;
                  margin-left: -15px;
                  color: #fff;
                }
                span {
                  display: inline-block;
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                  background-color: rgba(231, 231, 231, 1);
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                  background-image: url(../../../assets/img/h5/inviteLabel.png);
                  background-size: 11px 16px;
                  background-repeat: no-repeat;
                  background-position: center center;
                }
              }
            }
            li:not(:first-child) {
              margin-left: -12px;
            }
          }
        }
        .submit {
          background: rgba(201, 55, 61, 1);
          border-radius: 3px;
          margin-top: 37px;
          font-size: 14px;
          line-height: 20px;
          color: rgba(255, 255, 255, 1);
          font-weight: 600;
          padding: 13px 0;
        }
        .default {
          color: rgba(53, 54, 60, 1);
          background: rgba(247, 247, 247, 1);
        }
        .countDownBox {
          margin-top: 32px;
          text-align: center;
          p {
            font-size: 12px;
            line-height: 17px;
            color: rgba(174, 175, 177, 1);
            font-weight: 400;
          }
          .countDown {
            margin-top: 12px;
            span {
              font-size: 18px;
              line-height: 23px;
              color: rgba(45, 45, 45, 1);
              font-weight: bold;
              width: 36px;
              text-align: center;
              display: inline-block;
              background: rgba(247, 247, 247, 1);
              border-radius: 3px;
              padding: 8px 0;
              overflow: hidden;
              vertical-align: middle;
            }
            em {
              vertical-align: middle;
              margin: 0 6px;
              font-size: 11px;
              line-height: 16px;
              color: rgba(52, 55, 55, 0.4);
            }
          }
        }
      }
    }
    .common {
      margin: 24px 16px 0;
      padding-bottom: 24px;
      .commonTop {
        .title {
          text-align: center;
          font-size: 12px;
          line-height: 17px;
          color: rgba(53, 54, 60, 0.4);
          font-weight: 500;
        }
      }
      .commonContent {
        margin-top: 16px;
      }
    }
    .common:not(:last-child) {
      border-bottom: 0.5px solid rgba(224, 224, 224, 1);
    }
    .stepBox {
      ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        position: relative;
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          z-index: 10;
          div {
            padding: 0 14px;
            background: rgba(244, 244, 247, 1);
            i {
              display: inline-block;
              width: 20px;
              height: 20px;
              background: rgba(200, 200, 200, 1);
              color: rgba(255, 255, 255, 1);
              border-radius: 50%;
              font-size: 12px;
              line-height: 20px;
              text-align: center;
            }
          }

          .text {
            margin-top: 16px;
            text-align: center;
            font-size: 12px;
            line-height: 18px;
            color: rgba(0, 0, 0, 0.4);
            span {
              display: block;
            }
          }
        }
        li:first-child::before {
          content: " ";
          position: absolute;
          left: 0;
          width: 30%;
          top: 0;
          height: 20px;
          background: rgba(244, 244, 247, 1);
        }
        li:last-child::before {
          content: " ";
          position: absolute;
          right: 0;
          width: 30%;
          top: 0;
          height: 20px;
          background: rgba(244, 244, 247, 1);
        }
      }
      ul::before {
        content: " ";
        display: inline-block;
        border: 0.5px dashed rgba(185, 185, 185, 1);
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        z-index: 1;
      }
    }
    .rule {
      margin-top: 16px;
      li {
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.4);
        font-weight: 400;
      }
    }
  }
}
</style>